/**
 * The smallest touch target, 44px, as classes: a min-height (and, for a square control such as a dialog's
 * ✕, a min-width too) of `--touch-target`. index.css sets that property on the root in rem, so it follows
 * the root size, and again inside the 80% rule, so the target is still 44px there. A min-height wins over
 * a fixed height, so these grow a `Button` (`h-8` / `h-10`) without replacing its size.
 */
export const TOUCH_TARGET = 'min-h-[var(--touch-target)]';
export const TOUCH_TARGET_SQUARE = 'min-h-[var(--touch-target)] min-w-[var(--touch-target)]';
